import { render, staticRenderFns } from "./SlContent.vue?vue&type=template&id=b01060c0&"
import script from "./SlContent.vue?vue&type=script&lang=js&"
export * from "./SlContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports